import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

import InputGroup from './InputGroup';

import styles from './Input.scss';

interface TextAreaProps extends WrappedFieldProps {
  placeholder?: React.InputHTMLAttributes<HTMLInputElement>['placeholder'];
  label?: string;
}

const TextArea: React.SFC<TextAreaProps> = ({ input, label, placeholder, meta }) => (
  <InputGroup label={label} meta={meta}>
    <textarea {...input} className={styles.textarea} placeholder={placeholder} />
  </InputGroup>
);

export default (props: WrappedFieldProps) => <TextArea {...props} />;



// WEBPACK FOOTER //
// /www/client/src/components/Input/TextArea.tsx